import React from "react";

interface ConnectionFeesDetails {
  label: string;
  value: string;
}

const PriceDetail: React.FC<ConnectionFeesDetails> = ({ label, value }) => {
  if (value == '') {
    return;
  }
  const lowerText = value.toLocaleLowerCase();
  const text = lowerText == 'yes' ? 'Ja' : lowerText == 'no' ? 'Nej' : lowerText == 'partial' ? 'Delvist' : null 
  return (
    <div className="flex justify-between homepage-text-sm ">
      <div className="flex items-center gap-1">
        <span>{label}</span>
      </div>
      <span className="homepage-text-sm ">{text}</span>
    </div>
  );
};

export default PriceDetail;
